import createIcon from '../../createIcon';

/**
 * @component @name Bolt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuOTk2MiAyMUg5Ljk5NjIxTDEwLjk5NjIgMTRINy40OTYyMUM2LjkxNjIxIDE0IDYuOTI2MjEgMTMuNjggNy4xMTYyMSAxMy4zNEM3LjMwNjIxIDEzIDcuMTY2MjEgMTMuMjYgNy4xODYyMSAxMy4yMkM4LjQ3NjIxIDEwLjk0IDEwLjQxNjIgNy41NCAxMi45OTYyIDNIMTMuOTk2MkwxMi45OTYyIDEwSDE2LjQ5NjJDMTYuOTg2MiAxMCAxNy4wNTYyIDEwLjMzIDE2Ljk2NjIgMTAuNTFMMTYuODk2MiAxMC42NkMxMi45NTYyIDE3LjU1IDEwLjk5NjIgMjEgMTAuOTk2MiAyMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Bolt = createIcon('Bolt', [
  [
    'path',
    {
      d: 'M10.9962 21H9.99621L10.9962 14H7.49621C6.91621 14 6.92621 13.68 7.11621 13.34C7.30621 13 7.16621 13.26 7.18621 13.22C8.47621 10.94 10.4162 7.54 12.9962 3H13.9962L12.9962 10H16.4962C16.9862 10 17.0562 10.33 16.9662 10.51L16.8962 10.66C12.9562 17.55 10.9962 21 10.9962 21Z',
      key: 'djb5jz',
    },
  ],
]);

export default Bolt;
